<template>
    <div class="wrapright">
        <div class="btnbox">
            <router-link to="./enroll_en">REGISTRATION</router-link>
            <router-link to="./spon_en">SPONSORSHIP</router-link>
            <a target="_blank" href="http://static.hrflag.com/pdf/ddispon.pdf">DOWNLOAD</a>
        </div>
        <div class="logolist">
            <h6>Organizer</h6>
            <ul>
                <li><a href="javascript:;"><img style="width:90%;" src="../../assets/images/logobk.svg" alt=""></a></li>
            </ul>
            <h6>Co-organizer</h6>
            <ul>
                <li><a href="javascript:;"><img src="http://static.hrflag.com/img/spon/ddi-logo.png" alt=""></a></li>
                <li><a href="javascript:;"><img src="http://hrflag.com/img/zqlogogr.svg" alt=""></a></li>
            </ul>
            <h6>Academic Institutional Support</h6>
            <ul>
                <li><a href="javascript:;"><img src="http://edm.hrflag.com/imgs/lalogo.jpg" alt=""></a></li>
            </ul>
            <h6>Media Support</h6>
            <ul>
                <li><a href="javascript:;"><img src="http://static.hrflag.com/logo/pxzz.png" alt=""></a></li>
                <li><a href="javascript:;"><img src="../../assets/images/GHRlogo.jpg" alt=""></a></li>
            </ul>
            <h6>Intellectual Support</h6>
            <ul>
                <li><a href="javascript:;"><img src="../../assets/images/cho100.png" alt=""></a></li>
            </ul>
            <h6>Note Support</h6>
            <ul>
                <li><a href="javascript:;"><img src="../../assets/images/biji.svg" alt=""></a></li>
            </ul>
            <h6>Sponsors</h6>
            <ul>
                <li><a href="javascript:;"><img src="../../assets/images/weir.png" alt=""></a></li>
                <li><a href="javascript:;"><img src="../../assets/images/cubiks.png" alt=""></a></li>
                <li><a href="javascript:;"><img src="../../assets/images/gml.png" alt=""></a></li>
                <li><a href="javascript:;"><img src="../../assets/images/liepin.png" alt=""></a></li>
                <li><a href="javascript:;"><img src="../../assets/images/sea.png" alt=""></a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'wrapright',
    data () {
        return {
            lists: [
                {url1: ''},
                {url1: ''},
            ]
        }
    }
}
</script>

<style scoped>
    .wrapright {
        width: 200px;
        float: right;
        margin-top: 8.5%;
    }
    .btnbox a {
        display: block;
        width: 100%;
        padding: 10px 40px;
        border: solid 1px #fff;
        color: #fff;
        text-decoration: none;
        font-size: 16px;
        text-align: center;
        border-radius: 5px;
        margin: 0;
    }   
    .btnbox a:nth-child(1) {
        margin-left: 0;
        padding: 12px 40px;
        border: none;
        background: -webkit-gradient(linear, left top, right top, from(#e4912b) , to(#db7729));
        background: linear-gradient(to right, #e4912b , #db7729);
        margin-bottom: 20px;
    }
    .btnbox a:nth-child(1):hover {
        background: #e6833c;
    }
    .btnbox a:nth-child(2) {
        color: #333333;
        border: solid 1px #333333;
        margin-bottom: 20px;
    } 
    .btnbox a:nth-child(3) {
        color: #333333;
        border: solid 1px #333333;
    } 
    .btnbox a:nth-child(2):hover {
        background: -webkit-gradient(linear, left top, right top, from(transparent) , to(#4d4e49));
        background: linear-gradient(to right, transparent , #4d4e49);
        color: #fff;
    }
    .btnbox a:nth-child(3):hover {
        background: -webkit-gradient(linear, left top, right top, from(transparent) , to(#4d4e49));
        background: linear-gradient(to right, transparent , #4d4e49);
        color: #fff;
    }
    .logolist {
        width: 100%;
        text-align: center;
    }
    .logolist h6 {
        font-size: 16px;
        background: #555;
        padding: 5px 0;
        color: #fff;
        margin-top: 20px;
    }
    .logolist ul li{
        background: #ffffff;
        width: 100%;
        height: 110px;
        border-bottom: solid 1px #ccc;
    }
    .logolist ul li img {
        width: 150px;
        padding: 5px 0;
        text-align: center;
    }
    .logolist li a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    @media screen and (max-width:768px) {
        .wrapright {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commn/wrapright.vue